import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Select, Input } from '~/components/Form';
import { t, validCharacters } from '~/helpers';
import {
  storeLocalidade,
  updateLocalidade,
} from '~/store/modules/localidade/actions';

export default function CreateOrUpdate({ reference, data, create, ...props }) {
  const dispatch = useDispatch();

  const { loading, find, params } = useSelector((state) => state.localidade);

  const initials = create ? data : { ...find, ...data };

  useEffect(() => {
    console.log(props);
  }, [reference]);

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        idlocalidade: Yup.number()
          .typeError(t('s.geral.validacao.informeumnumero'))
          .integer(t('s.geral.validacao.informeumnumero'))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.valorminimo').replace('%s', 1))
          .max(
            9999999999,
            t('s.geral.validacao.tamanhomaximo').replace('%s', 10)
          ),
        nomelocalidade: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          ),

        statuslocalidade: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(1, t('s.geral.validacao.tamanhomaximo').replace('%s', 1)),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      const objSend = {
        ...initials,
        ...param,
        idlocalidade: Number(param.idlocalidade),
      };

      if (create) {
        await dispatch(storeLocalidade(objSend, params));
      } else {
        await dispatch(updateLocalidade(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          <Input
            name="idlocalidade"
            label={t('s.cadastro.motorista.idmotorista')}
            variant="outlined"
            fullWidth
            size="small"
            type="number"
            disabled={!create}
            InputLabelProps={{
              shrink: true,
            }}
          />

          <Input
            name="nomelocalidade"
            label={t('s.cadastro.motorista.nomemotorista')}
            variant="outlined"
            fullWidth
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />

          <Select
            name="statuslocalidade"
            variant="outlined"
            label={t('s.cadastro.motorista.statusmotorista')}
            options={[
              { value: 'L', label: t('s.geral.opcoes.liberado') },
              { value: 'B', label: t('s.geral.opcoes.bloqueado') },
              { value: 'C', label: t('s.geral.opcoes.cancelado') },
            ]}
          />
        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
